import { t } from 'i18next';
import { InputNumber } from 'primereact/inputnumber';
import { Tooltip } from 'primereact/tooltip';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/app/hooks';
import { ChuteSchedulerActions } from '@/app/slices/chuteScheduler';

type Props = {
  className?: string;
};

export const Interval = ({ className }: Props) => {
  const dispatch = useDispatch();
  const { interval } = useAppSelector((state) => state.chuteScheduler);

  const handleChange = (val: number | null) => {
    dispatch({
      type: ChuteSchedulerActions.UPDATE_INTERVAL,
      interval: val ?? 0,
    });
  };

  return (
    <div
      className={`${className ? `${className} ` : ''}label-input-group flex flex-col gap-1`}
    >
      <Tooltip
        target=".interval-help"
        position="top"
        content="Minutes between scheduled aspirations."
        className="max-w-xs"
      />

      <div className="flex items-center gap-1">
        <label>{t('chuteScheduler.interval')}</label>
        <i className="pi pi-info-circle interval-help cursor-help text-gray-400" />
      </div>

      <InputNumber
        className="custom-input-number h-10 w-full md:w-8"
        value={interval}
        onValueChange={(e) => handleChange(e.value ?? null)}
        mode="decimal"
        showButtons
        min={0}
        max={60}
        invalid={interval == null || interval < 0 || interval > 60}
      />
    </div>
  );
};
